import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../services/api";
import buildQuery from 'odata-query';
import _ from 'lodash';
import { getStructureTree, getUserFactoryId } from "../../../..";
import { parse } from "../../../helpers/three";

export const STRUCTURE_URL = '/structure'


/**
 * @param {Partial<import("odata-query").QueryOptions>} param0
 */
export const fetchStructure = createAsyncThunk(
    'filters/fetchStructure', async ( odata, action ) => {
        const response = await api.get(`${STRUCTURE_URL}/odata/` + buildQuery(_.merge(
            odata,
            {
                select: [ 'id','name','code' ],
                expand: {
                    father: {
                        select: [ 'id', 'name' ]
                    }
                },
                filter: {
                    status: true,
                },
                orderBy: ['name asc'],
                count: true
            },
        )));

        return response.data;
    }
)

export const updateTreeStructData = createAsyncThunk(
    'filters/updateTreeStructData',
    async ( param, action ) => {
        const structuresTree = await getStructureTree();
        const tree = structuresTree.structures
        return parse(tree)
    }
)

/**
 * 
 */
export const featchFilterProduct = createAsyncThunk(
    'filters/featchFilterProduct',
    async ({ enabledSearch, searchString }) => {
        const filter = {
            factoryId: getUserFactoryId(),
        }
        if ( enabledSearch ) {
            filter.name = {
                contains: searchString
            }
        }
        const response = await api.get('/product/odata/' + buildQuery({
            filter,
            select: [ 'id', 'name' ]
        }))

        return _.get(response.data, 'value', [])
    }
)

/**
 * 
 */
export const featchFilterDefectCategory = createAsyncThunk(
    'filters/featchFilterDefectCategory',
    async ({ enabledSearch, searchString }) => {
        const filter = {
            factoryId: getUserFactoryId(),
        }
        if ( enabledSearch ) {
            filter.name = {
                contains: searchString
            }
        }
        const response = await api.get('/DefectCategory/odata/' + buildQuery({
            filter,
            select: [ 'id', 'name' ]
        }))

        return _.get(response.data, 'value', [])
    }
)

/**
 * 
 */
export const featchFilterDefectType = createAsyncThunk(
    'filters/featchFilterDefectType',
    async ({ enabledSearch, searchString }) => {
        const filter = {
            factoryId: getUserFactoryId(),
        }
        if ( enabledSearch ) {
            filter.name = {
                contains: searchString
            }
        }
        const response = await api.get('/DefectType/odata/' + buildQuery({
            filter,
            select: [ 'id', 'name' ]
        }))

        return _.get(response.data, 'value', [])
    }
)